
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LandingFormData } from "../hooks/useLandingForm";

interface EmailSectionProps {
  formData: LandingFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const EmailSection = ({ formData, handleChange }: EmailSectionProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="email">Email Address *</Label>
      <p className="text-sm text-muted-foreground">A valid email address is required to access the product catalog</p>
      <Input
        id="email"
        name="email"
        type="email"
        required
        value={formData.email}
        onChange={handleChange}
        placeholder="your.email@company.com"
      />
    </div>
  );
};

export default EmailSection;
